export enum EPerformanceChartStat {
  IMPRESSIONS = 'Impressions',
  BUDGET = 'Budget',
}

export const performanceStatChartColors = {
  [EPerformanceChartStat.IMPRESSIONS]: ['#C7BCFF', '#947EFB'],
  [EPerformanceChartStat.BUDGET]: ['#7DC0FE', '#1488F4'],
};
